<div class="form-group" ngModelGroup="formField{{ formField.id }}" [ngClass]="{ 'padding-x-20px': isDateTime }">
    <!--    todo: check is it possible to replace with component-->
    @if (formField.label) {
        <label class="form-element-label" [ngClass]="{ 'mb-0': isDateTime }" for="form-element-{{ formField.id }}">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }
    <div class="data-picker" id="data-picker{{ formField.id }}">
        <div
            class="input-group"
            [ngClass]="{
                'ng-invalid':
                    formService.isSubmitted &&
                    ((date && dateField.invalid) || (!date && (formField.isRequired || time))),
            }">
            <input
                type="text"
                bsDatepicker
                id="form-element-{{ formField.id }}"
                class="form-control"
                placement="top"
                autocomplete="off"
                container="body"
                appFocus
                [appAutoFocus]="formField.isNeedToFocus"
                [attr.name]="formField.name || formField.id"
                [name]="formField.name || formField.id"
                [placeholder]="formField.placeholder"
                [ngClass]="{ 'ng-invalid': formService.isSubmitted && !date && (formField.isRequired || time) }"
                #dp="bsDatepicker"
                [ngModelOptions]="{ standalone: true }"
                #dateField="ngModel"
                [(ngModel)]="date"
                (ngModelChange)="updateDate()"
                [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false, adaptivePosition: true }" />
            <div class="input-group-append">
                <button
                    type="button"
                    class="btn btn-calender btn-icon"
                    aria-label="Calender picker"
                    [ngClass]="{ 'ng-invalid': formField.isRequired && !date, active: dp.isOpen }"
                    (click)="dp.toggle()"
                    tabindex="-1"
                    [attr.aria-expanded]="dp.isOpen">
                    <sb-inline-svg class="icon" [url]="'sb-tools/theme/images/calendar-icon.svg'"></sb-inline-svg>
                </button>
            </div>
        </div>

        @if (isDateTime) {
            <timepicker
                #timefield
                [showMeridian]="false"
                name="formField{{ formField.id }}"
                class="ms-3 time-control"
                (isValid)="isTimeValid = $event"
                [ngClass]="{
                    'ng-invalid':
                        formService.isSubmitted &&
                        ((formField.isRequired && !time) || (!isTimeValid && (timefield.hours || timefield.minutes))),
                }"
                (ngModelChange)="updateTime($event)"
                [(ngModel)]="time">
            </timepicker>
        }
    </div>

    @if (formService.isSubmitted && !date && time) {
        <div class="text-danger" translate>Please choose date</div>
    }
    @if (formService.isSubmitted && formField.isRequired && (!formField.value || (isDateTime && !time))) {
        <div class="text-danger" translate>Please fill this field</div>
    }
    @if (date && formService.isSubmitted && dateField.invalid) {
        <div class="text-danger">
            {{ 'Date format in the lane does not look quite right.' | translate }}<br />
            {{ 'Please try again.' | translate }}
        </div>
    }
</div>
